<template>
    <nav id="topnav" class="defaultscroll is-sticky">
        <div id="dropdown" />
        <div class="container">
            <!-- Logo container-->
            <Link :href="route('home')" class="logo pl-0 mt-2 mb-2">
                <logo class="pro-schedule-logo" />
            </Link>

            <!-- End Logo container-->
            <div class="menu-extras">
                <div class="menu-item">
                    <!-- Mobile menu toggle-->
                    <div class="navbar-toggle cursor-pointer" id="isToggle" @click="toggleMenu">
                        <div class="lines">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <!-- End mobile menu toggle-->
                </div>
            </div>


            <div id="navigation">
                <!-- Navigation Menu-->
                <ul class="navigation-menu">
                    <li :class="{'active' : active_menu === 'home'}"><Link :href="route('home')" @click="active_menu = 'home'" class="sub-menu-item">Home</Link></li>
                    <li class="has-submenu parent-parent-menu-item" :class="{'active' : active_menu === 'appointment'}">
                        <Link :href="route('appointment')" @click="active_menu = 'appointment'" class="sub-menu-item pr-4">Appointment</Link>
                        <span class="menu-arrow"></span>
                        <ul class="submenu">
                            <li v-for="(profession, pi) in $page.props.professions" :key="pi"><a :href="route('appointment', {'profession':profession.slug})" class="sub-menu-item">{{ profession.name }}</a></li>
                        </ul>
                    </li>
                    <li v-if="!!this.enable_option && this.enable_option.blog" :class="{'active' : active_menu === 'blog'}"><Link :href="route('blog')" @click="active_menu = 'blog'" class="sub-menu-item">Blog</Link></li>
                    <li :class="{'active' : active_menu === 'contact'}"><Link :href="route('contact')" @click="active_menu = 'contact'" class="sub-menu-item">Contact</Link></li>
                    <li class="" v-if="!!this.enable_option && this.enable_option.show_login && !$page.props.auth.user"><a :href="route('login')">Login</a></li>
                    <li class="dd__wrapper" v-if="$page.props.auth.user">
                        <dropdown class="mt-1 select_user" placement="bottom-end">
                            <template #default>
                                <div class="flex items-center cursor-pointer group">
                                    <div class=" mr-1 whitespace-nowrap">
                                        <img v-if="$page.props.auth.user.photo" class="user_photo w-8 h-8" :alt="$page.props.auth.user.first_name" :src="$page.props.auth.user.photo" />
                                        <img v-else src="/images/svg/profile.svg" class="w-8 h-8" alt="user profile" />
                                    </div>
                                    <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                                </div>
                            </template>
                            <template #dropdown>
                                <div class="shadow-xl bg-white rounded text-sm">
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" href="/dashboard">{{ __('Dashboard') }}</Link>
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" href="/dashboard/edit_profile">{{ __('Edit Profile') }}</Link>
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white w-full text-left" :href="route('logout')" method="delete" as="button">{{ __('Logout') }}</Link>
                                </div>
                            </template>
                        </dropdown>
                    </li>
                </ul><!--end navigation menu-->
            </div><!--end navigation-->
        </div><!--end container-->
    </nav>
</template>
<script>
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/inertia-vue3'
export default {
    components: {
        Logo,
        Icon,
        Dropdown,
        Link
    },
    data(){
        return {
            active_menu: 'home',
            enable_option: {}
        }
    },
    methods: {
        toggleMenu(){
            document.getElementById('isToggle').classList.toggle('open');
            var isOpen = document.getElementById('navigation')
            if (isOpen.style.display === "block") {
                isOpen.style.display = "none";
            } else {
                isOpen.style.display = "block";
            }
        },
        windowScroll(){
            const navbar = document.getElementById("topnav");
            if (navbar != null) {
                if (
                    document.body.scrollTop >= 50 ||
                    document.documentElement.scrollTop >= 50
                ) {
                    navbar.classList.add("nav-sticky");
                } else {
                    navbar.classList.remove("nav-sticky");
                }
            }
        }
    },
    mounted() {
      this.active_menu = this.$page.url.substr(1) || 'home'
    },
    created() {
        if(this.$page.props.enable_options){
            let options = JSON.parse(this.$page.props.enable_options.value)
            options.forEach(option=>{
                this.enable_option[option.slug] = !!option.value
            })
        }
        window.addEventListener('scroll', (ev) => {
            ev.preventDefault();
            this.windowScroll();
        })
    }
}
</script>
